import { PORTFOLIO_GALLERY_REGISTRY } from "./portfolioGalleryRegistry";

const BRAND_WEB_PATH = "/portfolio/brand-web";

/** 3D 카드 순환 순서 — 업종별로 포폴 이미지 수집 */
const CATEGORY_ORDER = [
  "corporate",
  "cafe",
  "restaurant",
  "hospital",
  "education",
  "commerce",
  "real-estate",
  "beauty-health",
];

/**
 * @typedef {{
 *   id: string,
 *   title: string,
 *   src: string,
 *   variantId: string,
 *   path: string,
 * }} FloatingCardGalleryItem
 */

/**
 * @typedef {{
 *   id: string,
 *   left: FloatingCardGalleryItem,
 *   right: FloatingCardGalleryItem,
 * }} FloatingCardGalleryPair
 */

/** @returns {FloatingCardGalleryItem[]} */
export function buildFloatingCardGalleryItems() {
  /** @type {FloatingCardGalleryItem[]} */
  const items = [];

  for (const variantId of CATEGORY_ORDER) {
    const config = PORTFOLIO_GALLERY_REGISTRY[variantId];
    if (!config?.images?.length) continue;

    for (const img of config.images) {
      if (!img.src) continue;
      items.push({
        id: `${variantId}-${img.id}`,
        title: img.title,
        src: img.src,
        variantId,
        path: `${BRAND_WEB_PATH}?variant=${encodeURIComponent(variantId)}`,
      });
    }
  }

  return items;
}

/** @returns {FloatingCardGalleryPair[]} */
export function buildFloatingCardGalleryPairs() {
  const items = buildFloatingCardGalleryItems();
  if (!items.length) return [];
  if (items.length === 1) {
    return [{ id: "pair-0", left: items[0], right: items[0] }];
  }

  /** @type {FloatingCardGalleryPair[]} */
  const pairs = [];

  for (let i = 0; i < items.length; i += 2) {
    const left = items[i];
    let right = items[i + 1] ?? items[(i + 1) % items.length];
    if (right.id === left.id && items.length > 1) {
      right = items[(i + 2) % items.length];
    }
    pairs.push({
      id: `pair-${pairs.length}`,
      left,
      right,
    });
  }

  return pairs;
}

export const FLOATING_CARD_GALLERY_PAIRS = buildFloatingCardGalleryPairs();

export const FLOATING_CARD_MESH_NAMES = ["Rectangle", "Rectangle 2"];
